import { useEffect } from 'react';
import '../shared/UndoToast.css';

// ============================================================
// UNDO TOAST — the light strip that follows a park / kill for the undo
// window. Text plus one Undo button plus a hairline that drains over
// `ttl`. Cmd/Ctrl+Z while it is visible undoes, unless the keystroke is
// typed into a field. The jump toast (monospace red-on-black) is a
// different thing and stays in Watch.js.
// ============================================================

const typing = (el) => {
  if (!el || el === document.body) return false;
  const tag = (el.tagName || '').toLowerCase();
  return tag === 'input' || tag === 'textarea' || tag === 'select' || el.isContentEditable === true;
};

export default function UndoToast({ text, onUndo, ttl = 5000 }) {
  useEffect(() => {
    const onKey = (e) => {
      if (!(e.metaKey || e.ctrlKey) || e.altKey || (e.key || '').toLowerCase() !== 'z') return;
      if (typing(e.target)) return;
      e.preventDefault();
      onUndo?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onUndo]);

  return (
    <div className="Watch-undo-toast" role="status" data-testid="undo-toast" style={{ '--ttl': `${ttl}ms` }}>
      <span className="Watch-undo-toast-text">{text}</span>
      <button type="button" className="Watch-undo-toast-btn" onClick={() => onUndo?.()}>Undo</button>
      <span className="Watch-undo-toast-bar" aria-hidden="true" />
    </div>
  );
}
